// /* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Stack,
  Switch,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from "@mui/material";
import {
  listRoomTypeDetails,
  updateBookingEngineVisibility,
  updateRoomtype,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Add, ArrowBack, Close, Remove } from "@mui/icons-material";
import { UpdatableField } from "../../components/TextField";
import { tokens } from "../../theme";
import { Formik } from "formik";
import MealPlansOfRoomType from "./mealPlansOfRoomType";
import RoomtypeOffers from "./roomtypeOffers";
import ImgListView from "../../components/ImgList";
import ImgUploaderInput from "../../components/ImgUploaderInput";
import RoomtypeOtaCount from "./roomtypeOtaCount";
import RoomtypeOtas from "./roomtypeOtas";
import PlusOrMinusButton from "../../components/PlusOrMinusButton";
import RoomtypeOtaRatePlans from "./roomtypeOtaRatePlans";
import AvailabilityUpdation from "../../components/AvailabilityUpdation";
import { toast } from "react-toastify";

const getMaxNumOfPeople = (data, max_no_of_people) => {
  if (data?.max_occupancy_rate && data?.max_occupancy_rate > 0) {
    if (max_no_of_people && max_no_of_people > 3) {
      return max_no_of_people;
    }
    return 3;
  } else if (data?.standard_rate && data?.standard_rate > 0) {
    return 2;
  } else {
    return 1;
  }
};

const textColor = {
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#dbdbdb",
  },
};

function RoomtypeDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [updation, setUpdation] = useState(false);
  // eslint-disable-next-line

  const [selectedHighlights, setSelectedHighlights] = useState([]);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [images, setImages] = useState([]);
  const [rateNumber, setRateNumber] = useState(1);
  const [tab, setTab] = useState(1);
  const [isBkeEnabled, setIsBkeEnabled] = useState(true);

  const { roomtypeDetails, highlights, facilities } = useSelector(
    ({ admin: { roomtypeDetails, highlights, facilities } }) => ({
      roomtypeDetails,
      highlights,
      facilities,
    })
  );
  const isRoomtypeEnhancement = useSelector(
    ({ registration: { hotelProfile } }) => hotelProfile.flexible_occupancy
  );
  const [isFlexibleOccupancy, setIsFlexibleOccupancy] = useState(
    !!roomtypeDetails?.flexible_occupancy
  );
  // Validation function for Formik
  const validate = (values) => {
    const errors = {};

    // Validate flexible occupancy fields if isFlexibleOccupancy is true
    if (isFlexibleOccupancy) {
      const fields = [
        "base_adults",
        "max_adults",
        "max_children",
        "max_occupancy",
      ];
      fields.forEach((field) => {
        const error = getOccupancyError(values, field);
        if (error) {
          errors[field] = error;
        }
      });
    }

    return errors;
  };
  useEffect(() => {
    document.title = "Room type details";
    dispatch(listRoomTypeDetails({ id: id }));
    setSelectedHighlights(roomtypeDetails?.highlights?.map((a) => a._id));
    setSelectedFacilities(roomtypeDetails?.facilities?.map((a) => a._id));
    setImages(roomtypeDetails?.images || []);
    setIsBkeEnabled(roomtypeDetails?.bke_visibility === false ? false : true);
    if (roomtypeDetails?.rates?.standard_rate > 0) {
      setRateNumber(2);
    }
    if (roomtypeDetails?.rates?.max_occupancy_rate > 0) {
      setRateNumber(3);
    }
    // eslint-disable-next-line
  }, [id]);

  const handleNumberFieldChange = (e, setFieldValue) => {
    const { name, value } = e.target;
    const parsedValue = Number(value);

    if (!isNaN(parsedValue)) {
      setFieldValue(name, parsedValue);
    }
  };

  const removeRate = (rateName, setFieldValue) => {
    if (rateNumber === 3) {
      setRateNumber(2);
    } else if (rateNumber === 2) {
      setRateNumber(1);
    }
    setFieldValue(`rates.${rateName}`, 0)
  };

  const addNewRate = (rates, setFieldValue) => {
    if (rateNumber === 1) {
      setRateNumber(2);
    } else if (rateNumber === 2) {
      setRateNumber(3);
    }
    if (getMaxNumOfPeople(rates) === 1) {
      setFieldValue("rates.standard_rate", 0)
    } else if (getMaxNumOfPeople(rates) === 2) {
      setFieldValue("rates.max_occupancy_rate", 0)
    }
  };

const handleFormSubmit = async (values) => {
  values.id = id;
  values.highlights = selectedHighlights;
  values.facilities = selectedFacilities;
  values.max_no_of_people = rateNumber;
  values.images = images;

  if (isFlexibleOccupancy) {
    if (
      !values?.base_adults ||
      !values?.max_adults ||
      !values?.max_children ||
      !values?.max_occupancy
    ) {
      toast.success("Please fill all the fields for flexible occupancy.");
      return;
    }

    values.flexible_occupancy = true;
  }

  await dispatch(updateRoomtype(values));

  setUpdation((prev) => !prev);
};

  const handleEnableFlexibleOccupancy = () => {
    if (isFlexibleOccupancy) {
      alert("Flexible occupancy is already enabled.");
      return;
    } else {
      setIsFlexibleOccupancy(true);
      setRateNumber(2);
      setUpdation(true);
    }
  };

  const LabeledField = ({ label, children }) => (
    <Stack direction="row" spacing={2}>
      <Typography width="70%">{label}</Typography>
      {children}
    </Stack>
  );

  return (
    <Box m="20px" mb={15}>
      <Formik
        onSubmit={handleFormSubmit}
        // initialValues={roomtypeDetails}
        initialValues={{
          ...roomtypeDetails,
          rates: {
            single_occupancy_rate:
              roomtypeDetails?.rates?.single_occupancy_rate ?? "",
            standard_rate: roomtypeDetails?.rates?.standard_rate ?? "",
            max_occupancy_rate:
              roomtypeDetails?.rates?.max_occupancy_rate ?? "",
            extra_bed_rate: roomtypeDetails?.rates?.extra_bed_rate ?? "",
            child_rate: roomtypeDetails?.rates?.child_rate ?? "",
          },
        }}
        validate={validate}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          setFieldValue,
          errors,
          touched,
        }) => (
          <form onSubmit={handleSubmit}>
            <Stack direction={"row"} alignItems={"end"} spacing={1} m="20px 0">
              <Button
                size="small"
                variant="outlined"
                onClick={() => navigate(-1)}
              >
                <ArrowBack fontSize="small" />
              </Button>
              <Typography
                fontWeight="bold"
                variant="h4"
                textTransform={"uppercase"}
                color={colors.greenAccent[500]}
                noWrap
              >
                {values?.name}
              </Typography>
            </Stack>

            <Box sx={{ borderBottom: 1, mb: 2, borderColor: "divider" }}>
              <Tabs
                value={tab}
                onChange={(e, n) => setTab(n)}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                aria-label="scrollable force tabs example"
              >
                <Tab value={1} label="Details" sx={{ fontWeight: "bold" }} />
                <Tab value={2} label="Meal Plans" sx={{ fontWeight: "bold" }} />
                <Tab value={3} label="Rates" sx={{ fontWeight: "bold" }} />
                <Tab value={4} label="OTA List" sx={{ fontWeight: "bold" }} />
                <Tab
                  value={6}
                  label="OTA Rate Plans"
                  sx={{ fontWeight: "bold" }}
                />
                <Tab value={5} label="OTA Counts" sx={{ fontWeight: "bold" }} />
              </Tabs>
            </Box>

            {tab === 1 && (
              <Box
                width="100%"
                p={2}
                borderRadius={2}
                backgroundColor={colors.primary[400]}
              >
                <Grid container columnSpacing={{ md: 4, xs: 2 }} rowSpacing={2}>
                  {/* Header Section */}
                  <Grid item xs={12}>
                    <Stack direction="row" justifyContent="end" spacing={2}>
                      {isRoomtypeEnhancement &&
                        (isFlexibleOccupancy ? (
                          <Typography
                            variant="subtitle2"
                            color={colors.greenAccent[500]}
                            fontWeight={700}
                          >
                            Flexible occupancy
                          </Typography>
                        ) : (
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleEnableFlexibleOccupancy}
                          >
                            Enable Flexible Occupancy
                          </Button>
                        ))}
                      {!updation ? (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => setUpdation(true)}
                        >
                          <b>Update</b>
                        </Button>
                      ) : (
                        <Stack direction="row" spacing={1}>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => setUpdation(false)}
                          >
                            <Close fontSize="small" />
                          </Button>
                          <Button
                            size="small"
                            type="submit"
                            variant="contained"
                          >
                            <b>Save</b>
                          </Button>
                        </Stack>
                      )}
                    </Stack>
                  </Grid>

                  {/* Left Column */}
                  <Grid item md={6} xs={12}>
                    <Stack spacing={2}>
                      {/* Basic Info */}
                      <LabeledField label="Name:">
                        <UpdatableField
                          name="name"
                          fullWidth
                          required
                          multiline
                          maxRows={2}
                          size="small"
                          type="text"
                          sx={textColor}
                          disabled={!updation}
                          value={values?.name || ""}
                          onChange={handleChange}
                        />
                      </LabeledField>

                      <LabeledField label="Description:">
                        <UpdatableField
                          name="description"
                          fullWidth
                          multiline
                          maxRows={10}
                          size="small"
                          type="text"
                          sx={textColor}
                          disabled={!updation}
                          value={values?.description || ""}
                          onChange={handleChange}
                        />
                      </LabeledField>

                      {/* Conditional Fields */}
                      {localStorage.getItem("isDependent") === "true" && (
                        <LabeledField label="Number of rooms:*">
                          {!updation ? (
                            <UpdatableField
                              name="display_room_no"
                              fullWidth
                              required
                              size="small"
                              type="number"
                              placeholder="Number of rooms"
                              disabled={!updation}
                              sx={textColor}
                              value={values?.display_room_no || 0}
                              onChange={handleChange}
                              inputProps={{ min: 1 }}
                            />
                          ) : (
                            <PlusOrMinusButton
                              min={0}
                              max={200}
                              size="small"
                              value={values?.display_room_no || 0}
                              handleChange={(v) =>
                                setFieldValue("display_room_no", v)
                              }
                            />
                          )}
                        </LabeledField>
                      )}

                      {/* Highlights */}
                      <LabeledField label="Highlights:">
                        <UpdatableField
                          select
                          fullWidth
                          size="small"
                          sx={textColor}
                          disabled={!updation}
                          value={selectedHighlights || []}
                          SelectProps={{ multiple: true }}
                          onChange={(e) =>
                            setSelectedHighlights(e.target.value)
                          }
                        >
                          {highlights?.list?.map((e) => (
                            <MenuItem key={e._id} value={e._id}>
                              <Checkbox
                                sx={{ p: "0 5px" }}
                                size="small"
                                checked={selectedHighlights?.includes(e._id)}
                              />
                              {e.name}
                            </MenuItem>
                          ))}
                        </UpdatableField>
                      </LabeledField>

                      {/* Facilities */}
                      <LabeledField label="Facilities:">
                        <UpdatableField
                          select
                          fullWidth
                          size="small"
                          sx={textColor}
                          disabled={!updation}
                          value={selectedFacilities || []}
                          SelectProps={{ multiple: true }}
                          onChange={(e) =>
                            setSelectedFacilities(e.target.value)
                          }
                        >
                          {facilities?.list?.map((e) => (
                            <MenuItem key={e._id} value={e._id}>
                              <Checkbox
                                sx={{ p: "0 5px" }}
                                size="small"
                                checked={selectedFacilities?.includes(e._id)}
                              />
                              {e.name}
                            </MenuItem>
                          ))}
                        </UpdatableField>
                      </LabeledField>

                      <Divider />

                      {/* Flexible Occupancy Fields */}
                      {isFlexibleOccupancy && (
                        <>
                          <LabeledField label="Base adults:">
                            <Stack
                              direction="column"
                              spacing={0.5}
                              width="100%"
                            >
                              <UpdatableField
                                name="base_adults"
                                fullWidth
                                required
                                size="small"
                                type="number"
                                sx={textColor}
                                disabled={!updation}
                                value={values?.base_adults || 0}
                                onChange={(e) =>
                                  handleNumberFieldChange(e, setFieldValue)
                                }
                                inputProps={{ min: 1 }}
                              />
                              {touched.base_adults && errors.base_adults && (
                                <Typography color="error" variant="caption">
                                  {errors.base_adults}
                                </Typography>
                              )}
                            </Stack>
                          </LabeledField>
                          <LabeledField label="Maximum adults:">
                            <Stack
                              direction="column"
                              spacing={0.5}
                              width="100%"
                            >
                              <UpdatableField
                                name="max_adults"
                                fullWidth
                                required
                                size="small"
                                type="number"
                                sx={textColor}
                                disabled={!updation}
                                value={values?.max_adults || 0}
                                onChange={(e) =>
                                  handleNumberFieldChange(e, setFieldValue)
                                }
                                inputProps={{ min: 1 }}
                              />
                              {touched.max_adults && errors.max_adults && (
                                <Typography color="error" variant="caption">
                                  {errors.max_adults}
                                </Typography>
                              )}
                            </Stack>
                          </LabeledField>
                          <LabeledField label="Maximum children:">
                            <Stack
                              direction="column"
                              spacing={0.5}
                              width="100%"
                            >
                              <UpdatableField
                                name="max_children"
                                fullWidth
                                required
                                size="small"
                                type="number"
                                sx={textColor}
                                disabled={!updation}
                                value={values?.max_children || 0}
                                onChange={(e) =>
                                  handleNumberFieldChange(e, setFieldValue)
                                }
                                inputProps={{ min: 1 }}
                              />
                              {touched.max_children && errors.max_children && (
                                <Typography color="error" variant="caption">
                                  {errors.max_children}
                                </Typography>
                              )}
                            </Stack>
                          </LabeledField>
                          <LabeledField label="Maximum occupancy:">
                            <Stack
                              direction="column"
                              spacing={0.5}
                              width="100%"
                            >
                              <UpdatableField
                                name="max_occupancy"
                                fullWidth
                                required
                                size="small"
                                type="number"
                                sx={textColor}
                                disabled={!updation}
                                value={values?.max_occupancy || 0}
                                onChange={(e) =>
                                  handleNumberFieldChange(e, setFieldValue)
                                }
                                inputProps={{ min: 1 }}
                              />
                              {touched.max_occupancy &&
                                errors.max_occupancy && (
                                  <Typography color="error" variant="caption">
                                    {errors.max_occupancy}
                                  </Typography>
                                )}
                            </Stack>
                          </LabeledField>
                        </>
                      )}

                      {/* Read-Only Info */}
                      {!isFlexibleOccupancy && (
                        <LabeledField label="Max. number of people / room:">
                          <Typography>
                            {values.display_room_no === 0
                              ? getMaxNumOfPeople(
                                  values.rates,
                                  values?.max_no_of_people
                                )
                              : getMaxNumOfPeople(values.rates) *
                                values.display_room_no}
                          </Typography>
                        </LabeledField>
                      )}

                      <LabeledField label="Total rooms:">
                        <Typography>{values?.total_rooms}</Typography>
                      </LabeledField>

                      <LabeledField label="Availability:">
                        <Chip
                          variant="outlined"
                          label={values?.is_active ? "active" : "inactive"}
                          color={values?.is_active ? "primary" : "warning"}
                        />
                      </LabeledField>

                      {localStorage.getItem("isDependent") === "true" && (
                        <LabeledField label="Private:">
                          <Switch
                            checked={values?.is_private}
                            disabled={!updation}
                            onChange={(e) =>
                              setFieldValue("is_private", e.target.checked)
                            }
                          />
                        </LabeledField>
                      )}

                      {!updation && (
                        <LabeledField label="Show on booking engine:">
                          <AvailabilityUpdation
                            isActive={isBkeEnabled}
                            action={() => {
                              setIsBkeEnabled(!isBkeEnabled);
                              dispatch(updateBookingEngineVisibility({ id }));
                            }}
                          />
                        </LabeledField>
                      )}
                    </Stack>
                  </Grid>

                  {/* Right Column */}
                  <Grid item md={6} xs={12}>
                    <Stack spacing={2}>
                      <Typography
                        variant="h4"
                        color={colors.greenAccent[500]}
                        fontWeight={700}
                      >
                        Rates
                      </Typography>

                      {/* Rates */}
                      <LabeledField label="Single occupancy rate:">
                        <UpdatableField
                          key="single_occupancy_rate"
                          name="rates.single_occupancy_rate"
                          fullWidth
                          required
                          size="small"
                          type="number"
                          sx={textColor}
                          disabled={!updation}
                          value={values.rates.single_occupancy_rate}
                          onChange={(e) =>{
                            setFieldValue(
                              "rates.single_occupancy_rate",
                              Number(e.target.value)
                            )
                            // handleRateChange(e, "single_occupancy_rate") 
                          }}
                          inputProps={{ min: 1 }}
                        />
                      </LabeledField>

                      {rateNumber >= 2 && (
                        <LabeledField label="Double / Base occupancy rate:">
                          <UpdatableField
                            name="rates.standard_rate"
                            fullWidth
                            required
                            size="small"
                            type="number"
                            sx={textColor}
                            disabled={!updation}
                            value={values.rates.standard_rate}
                             onChange={(e) =>{
                            setFieldValue(
                              "rates.standard_rate",
                              Number(e.target.value)
                            )
                            //  handleRateChange(e, "standard_rate")
                          }}
                            inputProps={{ min: values.rates?.standard_rate }}
                            InputProps={
                              updation && !isFlexibleOccupancy
                                ? {
                                    endAdornment: (
                                      <InputAdornment
                                        sx={{ mr: -1 }}
                                        position="end"
                                      >
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          title="Remove rate"
                                          onClick={() =>
                                            removeRate("standard_rate", setFieldValue)
                                          }
                                          disabled={rateNumber === 3}
                                        >
                                          <Remove />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }
                                : {}
                            }
                          />
                        </LabeledField>
                      )}
                      {!isFlexibleOccupancy && rateNumber >= 3 ? (
                        <LabeledField label=" Triple occupancy rate:">
                          <UpdatableField
                            fullWidth
                            required
                            size="small"
                            type="number"
                            name="rates.max_occupancy_rate"
                            key="max_occupancy_rate"
                            sx={textColor}
                            disabled={!updation}
                            value={values.rates.max_occupancy_rate}
                            onChange={(e) => {
                               setFieldValue(
                              "rates.max_occupancy_rate",
                              Number(e.target.value)
                            )
                              // handleRateChange(e, "max_occupancy_rate")
                            }
                            }
                            // inputProps={{ min: values?.rates?.standard_rate }}
                            InputProps={
                              updation
                                ? {
                                    endAdornment: (
                                      <InputAdornment
                                        sx={{ mr: -1 }}
                                        position="end"
                                      >
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          title="Remove rate"
                                          onClick={() =>
                                            removeRate("max_occupancy_rate", setFieldValue)
                                          }
                                        >
                                          <Remove />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }
                                : {}
                            }
                          />
                        </LabeledField>
                      ) : null}
                      {!isFlexibleOccupancy && updation && (
                        <LabeledField label="">
                          <Button fullWidth size="small" 
                           onClick={() => addNewRate(values, setFieldValue)}
                           >
                            <Add />
                            <b>Add new rate</b>
                          </Button>
                        </LabeledField>
                      )}

                      {isFlexibleOccupancy && (
                        <LabeledField label="Extra bed rate:">
                          <UpdatableField
                            key="extra_bed_rate"
                            name="rates.extra_bed_rate"
                            fullWidth
                            required
                            size="small"
                            type="number"
                            sx={textColor}
                            disabled={!updation}
                            value={values.rates.extra_bed_rate}
                            onChange={(e) => {
                            setFieldValue(
                              "rates.extra_bed_rate",
                              Number(e.target.value)
                            )
                            // handleRateChange(e, "extra_bed_rate");
                          }
                          }
                            inputProps={{ min: 1 }}
                          />
                        </LabeledField>
                      )}

                      <LabeledField label="Child rate:">
                        <UpdatableField
                          key="child_rate"
                          name="rates.child_rate"
                          fullWidth
                          size="small"
                          type="number"
                          sx={textColor}
                          disabled={!updation}
                          value={values.rates.child_rate}
                            onChange={(e) => {
                            setFieldValue(
                              "rates.child_rate",
                              Number(e.target.value)
                            )
                            // handleRateChange(e, "child_rate");
                          }}
                        />
                      </LabeledField>
                    </Stack>

                    {/* Images */}
                    <Stack mt={2} spacing={2}>
                      <Typography
                        variant="h4"
                        color={colors.greenAccent[500]}
                        fontWeight={700}
                      >
                        Images
                      </Typography>
                      {!updation ? (
                        <ImgListView images={roomtypeDetails?.images || []} />
                      ) : (
                        <ImgUploaderInput
                          images={images || []}
                          onChange={setImages}
                        />
                      )}
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            )}
          </form>
        )}
      </Formik>

      {tab === 2 && (
        <MealPlansOfRoomType
          roomtypeId={id}
          dispatch={dispatch}
          colors={colors}
        />
      )}
      {tab === 3 && (
        <RoomtypeOffers
          roomtypeId={id}
          rates={roomtypeDetails?.rates}
          dispatch={dispatch}
          colors={colors}
          roomtypeDetails={roomtypeDetails}
        />
      )}
      {tab === 4 && (
        <RoomtypeOtas roomtypeId={id} dispatch={dispatch} colors={colors} />
      )}
      {tab === 5 && (
        <RoomtypeOtaCount roomtypeId={id} dispatch={dispatch} colors={colors} />
      )}
      {tab === 6 && (
        <RoomtypeOtaRatePlans
          roomtypeId={id}
          dispatch={dispatch}
          colors={colors}
        />
      )}
    </Box>
  );
}

export default RoomtypeDetails;

function getOccupancyError(roomType, field) {
  const { base_adults, max_adults, max_occupancy, max_children } = roomType;
  if (field === "base_adults" && Number(base_adults) < 1) {
    return "Base adults must be at least 1";
  }
  if (
    field === "max_adults" &&
    (Number(max_adults) < Number(base_adults) || Number(max_adults) < 1)
  ) {
    return "Max adults must be at least base adults";
  }
  if (field === "max_occupancy") {
    const adults = Number(max_adults);
    const children = Number(max_children);
    const occupancy = Number(max_occupancy);
    const total = adults + children;

    if (occupancy < adults || occupancy > total) {
      return `Max occupancy must be between max adults and the sum of max adults and max children (${adults} ≤ occupancy ≤ ${total})`;
    }
  }
  return "";
}
